import { Container } from 'aurelia-framework';
import { I18N } from 'aurelia-i18n';

import { CustomisationConfig } from '~/components/customisation/customisation-config';
import { LayoutOptions } from '~/layouts/layout-options';

export function getAreaNames(customisationConfigTemplate: string): string[] {
	if (!customisationConfigTemplate) {
		return [];
	}
	const areaNames: string[] = [];
	const allCustomisationsAreasEl = document.createElement('div');
	// eslint-disable-next-line @microsoft/sdl/no-inner-html
	allCustomisationsAreasEl.innerHTML = customisationConfigTemplate;
	allCustomisationsAreasEl
		.querySelectorAll('customisable-area')
		.forEach((el) => {
			const name = el.getAttribute('name');
			if (!name) {
				return;
			}
			areaNames.push(name);
		});
	return areaNames;
}

export function getAreaTemplate(
	customisationConfigTemplate: string,
	areaName: string,
): string {
	const i18n: I18N = Container.instance.get(I18N);
	if (!customisationConfigTemplate || !customisationConfigTemplate.trim()) {
		throw new Error(i18n.tr('customisable-area.empty-file'));
	}
	const el = document.createElement('div');
	// eslint-disable-next-line @microsoft/sdl/no-inner-html
	el.innerHTML = customisationConfigTemplate;
	const customisationAreaEl = el.querySelector(
		`customisable-area[name="${areaName}"]`,
	);
	if (!customisationAreaEl) {
		throw new Error(
			i18n.tr('customisable-area.missing', {
				'customisable-area': areaName,
			}),
		);
	}
	const customisationHtml = customisationAreaEl.innerHTML;
	if (!customisationHtml.trim()) {
		throw new Error(
			i18n.tr('customisable-area.empty', {
				'customisable-area': areaName,
			}),
		);
	}
	const templateEl = customisationAreaEl.querySelector('template');
	if (!templateEl) {
		throw new Error(
			i18n.tr('customisable-area.template-missing', {
				'customisable-area': areaName,
			}),
		);
	}
	return customisationHtml;
}
